import React, { Fragment } from 'react';
const navItems = [{
  label: 'NEWS',
  bold: false
}, {
  label: 'BRANDS',
  bold: false
}, {
  label: 'AGENCIES',
  bold: false
}, {
  label: 'FOCUS',
  bold: false
}, {
  label: 'EDITIONS',
  bold: false
}, {
  label: 'RANKING',
  bold: false
}, {
  label: 'CONTACT',
  bold: true
}];
const socialIcons = [{
  src: 'https://cdn.magicpatterns.com/uploads/h62UQ5wuL8ryFTzeqmkjfb/linkedin_725397_1.svg',
  alt: 'LinkedIn',
  wide: false
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2NQn2cRJrNNtjPyeRyt874/instagram_725339_1.svg',
  alt: 'Instagram',
  wide: false
}, {
  src: 'https://cdn.magicpatterns.com/uploads/55bc4Ahb44HUjbjfpnG9mU/x_twitter_icon_similar_1.svg',
  alt: 'X/Twitter',
  wide: false
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kHXxWQisVWhhus7w413MkB/youtube.svg',
  alt: 'YouTube',
  wide: true
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wbgmfwGdC6xEn6HB7v8LhK/facebook_725350_1.svg',
  alt: 'Facebook',
  wide: false
}];
export function Footer() {
  return <footer className="site-footer mt-6" data-id="element-65">
      <div className="site-footer-inner px-4 md:px-6 lg:px-0" style={{
      minHeight: '200px'
    }} data-id="element-66">
        {/* Nav Links */}
        <nav className="flex flex-wrap justify-center items-center pt-5 lg:pt-6 pb-6 lg:pb-8" data-id="element-67">
          {navItems.map((item, index, array) => <Fragment key={item.label} data-id="element-68">
              <a href={`#${item.label.toLowerCase()}`} className={`text-white text-footer-nav text-upper hover:opacity-70 transition-opacity ${item.bold ? 'font-bold' : 'font-normal'}`} style={{
            letterSpacing: '0.14em'
          }} data-id="element-69">
                {item.label}
              </a>
              {index < array.length - 1 && <span className="text-white text-footer-nav mx-2 lg:mx-3" style={{
            letterSpacing: '0.14em'
          }} data-id="element-70">
                  I
                </span>}
            </Fragment>)}
        </nav>

        {/* Social Icons */}
        <div className="flex items-center justify-center gap-5 lg:gap-8 pb-6 lg:pb-8" data-id="element-71">
          {socialIcons.map(icon => <a key={icon.alt} href="#" className="flex items-center justify-center hover:opacity-70 transition-opacity" style={{
          width: icon.wide ? '75px' : '55px',
          height: '55px'
        }} data-id="element-72">
              <img src={icon.src} alt={icon.alt} className={`h-[40px] md:h-[50px] lg:h-[55px] ${icon.wide ? 'w-[55px] md:w-[65px] lg:w-[75px]' : 'w-[40px] md:w-[50px] lg:w-[55px]'}`} data-id="element-73" />
            </a>)}
        </div>

        {/* Copyright */}
        <p className="text-white text-footer-copy text-center pb-5 lg:pb-6" style={{
        letterSpacing: '0.14em'
      }} data-id="element-74">
          ®Communicate – All Rights reserved 2026 – Special Edition FZ
        </p>
      </div>
    </footer>;
}